import type { MouseEvent } from 'react';
import { useState } from 'react';

export const useDisclosure = ({
  defaultOpen = false,
  onClose = () => {},
  onOpen = () => {},
} = {}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleOpen = (e: MouseEvent) => {
    e.preventDefault();
    setIsOpen(true);
    onOpen();
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
    isOpen ? onClose() : onOpen();
  };

  return {
    isOpen,
    onClose: handleClose,
    onOpen: handleOpen,
    onToggle: handleToggle,
  };
};
